/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useEditableContextNodeSort} from "../../../Hooks/SortHooks";
import {useEffectPromise} from "../../../Hooks/EffectHooks";
import {service as ContextNodeService} from "../../../Services/ContextNodeService";
import {ChildrenList} from "./ChildrenList";
import {EditableContextNodeListItem} from "./EditableContextNodeListItem";
import {useState} from "react";

export const ContextNodeChildrenList = props => {
	
	const {
		title = null,
		context,
		itemsFromProps,
		itemComponent: ItemComponent = EditableContextNodeListItem,
		sort,
		hidden,
		...childrenListProps
	} = props;
	
	const defaultSort = useEditableContextNodeSort()
	
	const [items, setItems] = useState(null);
	
	useEffectPromise(
		async () => {
			if(itemsFromProps) {
				return itemsFromProps;
			}
			if(context == null) {
				return null;
			}
			setItems(null);
			try {
				return (await ContextNodeService.GetChildrenContextNodes({
					...context,
					contextNodeTypeId: context.contextNodeTypeId + 1,
				}))
					?.result ?? [];
			} finally {
				setItems([]); // Set to empty array if still null (in case of error)
			}
		},
		setItems,
		[itemsFromProps, context],
		true
	);
	
	return <ChildrenList
		title={title ?? ""}
		items={itemsFromProps ?? items}
		sort={sort ?? defaultSort}
		itemComponent={ItemComponent}
		{...childrenListProps}
	/>
};
